import { axiosInstanceFgts } from "./axiosInstance";

export interface ValidateUserInfoResponse {
  unicoId: string;
  user: {
    userId: string;
    name: string;
    document: string;
    lastName: string;
    email: string | null;
    cellphone: string | null;
  };
}

interface UpdatePartialUserRequest {
  email: string;
  cellphone: string;
}

// Identificação pelo userId (o mesmo login usado para entrar na plataforma).
// Resolve o caso de um CPF com várias contas sem expor nada na URL.
export const validateUserInfo = async (
  userId: string
): Promise<ValidateUserInfoResponse> => {
  try {
    const response = await axiosInstanceFgts.post<
      ValidateUserInfoResponse | ValidateUserInfoResponse[]
    >("/api/anti-fraud/users-info/validate", { userId });

    const data = response.data;
    const normalized = Array.isArray(data) ? data[0] : data;

    if (!normalized?.user) {
      throw new Error("Resposta de validação sem dados do usuário.");
    }

    return normalized;
  } catch (error) {
    console.error("Erro ao validar informações do usuário:", error);
    throw error;
  }
};

export const updatePartialUser = async (
  userId: string,
  data: UpdatePartialUserRequest
) => {
  try {
    const response = await axiosInstanceFgts.patch(`/api/user/${userId}`, data);
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar dados do usuário:", error);
    throw error;
  }
};

// Etapa de registro de localização (obrigatória) do fluxo plat_.
// Fluxo baseado em CPF: o userId vem do /validate.
export const registerAntiFraudLocation = async (data: {
  userId: string;
  latitude: number;
  longitude: number;
}) => {
  try {
    const response = await axiosInstanceFgts.post(
      "/api/anti-fraud/users-info/location",
      data
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao registrar localização:", error);
    throw error;
  }
};
